module.exports = __webpack_public_path__ + "img/icon-sun.aafe9065.svg";